














































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import Collapse from '../collapse/collapse.vue';
import Video from '../video/video.vue';

@Component({
  components: { Collapse, Video }
})
export default class CommonStep extends Vue {
  @Prop({ default: undefined, type: String })
  nkey: any;
  @Getter steps: any;

  // @Watch('$route')
  // onChildChanged(to: any, from: any) {
  //   const { params: { hkey } } = to;
  //   this.setData(hkey);
  // }
  // @Prop({ default: null, type: String })
  // hkey: any;

  // beforeMount() {
  //   const { params: { hkey } } = this.$route;
  //   this.setData(hkey);
  // }
  isArray(val: any) {
    return Array.isArray(val);
  }
  get item() {
    return this.nkey && this.steps ? this.steps[this.nkey] : {};
  }

  setData(val: string) {
    // this.nkey = val;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/vpm-steps/common-step.vue